<template>
  <div class="master-sub">

    <!--#region -- Modal ---->
    <b-modal centered ok-title="Substitute" size="xl"
             ref="signflowModal" title="NRE Signflow" hide-footer>

      <div v-if="adminRole && nreData !== null &&  nreData.page_object !== null">
        <ul>
          <li><b>GRO</b>: {{nreData.page_object.basic_info_review.sign_flow_members.GRO}}</li>
        </ul>
        <ul v-for="(signer, signerIndex) in nreData.page_object.basic_info_review.sign_flow_members">
          <li v-if="signerIndex !== 'FTIE_ID' && signerIndex !== 'GRO'">
            <b>{{signerIndex}}</b>: {{signer}}
          </li>
        </ul>
      </div>

      <!-- #endregion-->

    </b-modal>

    <b-modal centered ok-title="Substitute" @ok="substituteSku"
             ref="SubstituteModal" title="Substitute Reference SKU ID"
             button-size="sm">
      <div class="header-col border-bottom pb-4">
        <div>Reference SKU ID</div>
        <div>{{ _.get(skuItem, 'sku_id', '') }}</div>
      </div>
      <div class="pt-4">Please key in one similar SKU ID to substitute SKU ID.</div>
      <div class="header-col validate">
        <div>Similar SKU ID<span class="text-danger pl-1">*</span></div>
        <div>
          <input type="text" class="form-control form-control-sm" required
                 v-model="substituteObj.skuId" :class="{'is-invalid': _.get(substituteObj, 'state', false)}" />
          <div class="invalid-feedback">{{_.get(substituteObj, 'errMsg', '')}}</div>
        </div>
      </div>
    </b-modal>

    <!-- ETO Sector SKU QUOTE ITEM MODAL-->
    <b-modal centered :ok-title="quoteItemObj.action" @ok="saveQuoteItem"
             ref="ETOSelectQuoteItemModal" :title="quoteItemObj.action + ' ETO Sector SKU Quote Items'"
             button-size="sm">
      <div class="header-col">
        <div>Project Name (OPTY)</div>
        <div>{{ quoteItemObj.sales_force_opty }}</div>
      </div>
      <div class="header-col">
        <div>FTIE ID</div>
        <div>{{ quoteItemObj.ftie_id }}</div>
      </div>
      <div class="border-bottom"></div>
      <div class="header-col mt-4 validate">
        <div>Quote Type<span class="text-danger pl-1">*</span></div>
        <div>
          <b-form-select size="sm" v-model="quoteItemObj.quote_type" :options="aliveQuoteTypes"
                         required :class="{'is-invalid': _.get(quoteItemObj, 'quote_type_state', false)}"
                         @change="quoteTypeChanged">
          </b-form-select>
          <div class="invalid-feedback">Please enter Quote Type</div>
        </div>
      </div>
      <div class="header-col validate">
        <div>Quantity<span class="text-danger pl-1">*</span></div>
        <div>
          <select class="form-control form-control-sm max-w-5 text-right" v-model.number="quoteItemObj.qty"
                  required :class="{'is-invalid': _.get(quoteItemObj, 'qty_state', false)}">
            <option v-for="index in quoteItemObj.qtyMax" :value="index">{{ index }}</option>
          </select>
          <div class="invalid-feedback">Please enter Quantity</div>
        </div>
      </div>

      <div class="header-col flex-wrap">
        <div class="text-nowrap">SKU Description for ETO Sector SKU</div>
        <div class="w-100">
          <textarea class="w-100" v-model="quoteItemObj.customization_description"></textarea>
        </div>
      </div>

      <!--
            <div v-if="_.get(nreData, 'page_object.basic_info_review.eto_sector_sku', null) !== null"
         class="header-col flex-wrap">
      <div class="text-nowrap">Remark for the condition and terms for ETO Sector SKU</div>
      <div class="w-100">
        <textarea class="w-100"
                  v-model="nreData.page_object.basic_info_review.eto_sector_sku.remark">
        </textarea>
      </div>
    </div>
    -->

    </b-modal>
    <!--  _.get(this.nreData, 'page_object.basic_info_review.eto_sector_sku', null)
  quoteItemObj.remark-->
    <!-- END REGION ETO Sector SKU-->


    <b-modal centered :ok-title="quoteItemObj.action" @ok="saveQuoteItem"
             ref="QuoteItemModal" :title="quoteItemObj.action + ' Customize Quote Items'"
             button-size="sm">
      <div class="header-col">
        <div>Salesforce Opportunity</div>
        <div>{{ quoteItemObj.sales_force_opty }}</div>
      </div>
      <div class="header-col">
        <div>FTIE ID</div>
        <div>{{ quoteItemObj.ftie_id }}</div>
      </div>
      <div class="header-col mb-4">
        <div>Customization SKU ID</div>
        <div>{{ quoteItemObj.sku_id }}</div>
      </div>
      <div class="border-bottom"></div>
      <div class="header-col mt-4 validate">
        <div>Quote Type<span class="text-danger pl-1">*</span></div>
        <div>
          <b-form-select size="sm" v-model="quoteItemObj.quote_type" :options="aliveQuoteTypes"
                         required :class="{'is-invalid': _.get(quoteItemObj, 'quote_type_state', false)}"
                         @change="quoteTypeChanged">
          </b-form-select>
          <div class="invalid-feedback">Please enter Quote Type</div>
        </div>
      </div>
      <div class="header-col validate">
        <div>Quantity<span class="text-danger pl-1">*</span></div>
        <div>
          <select class="form-control form-control-sm max-w-5 text-right" v-model.number="quoteItemObj.qty"
                  required :class="{'is-invalid': _.get(quoteItemObj, 'qty_state', false)}">
            <option v-for="index in quoteItemObj.qtyMax" :value="index">{{ index }}</option>
          </select>
          <div class="invalid-feedback">Please enter Quantity</div>
        </div>
      </div>
      <div class="header-col flex-wrap">
        <div>SKU Description</div>

        <!--
          <div v-if="_.get(nreData, 'page_object.basic_info_review.region', '') === 'GUSA'" class="w-100">
            <b-form-textarea class="w-100" id="textarea-plaintext" plaintext :value="quoteItemObj.sku_description"></b-form-textarea>
          </div>
  -->

        <div class="w-100">
          <textarea class="w-100" v-model="quoteItemObj.sku_description"></textarea>
        </div>
      </div>
      <div class="header-col flex-wrap">
        <div class="text-nowrap">Customization Description</div>
        <div class="w-100">
          <textarea class="w-100" v-model="quoteItemObj.customization_description"></textarea>
        </div>
      </div>
    </b-modal>

    <b-modal centered ok-title="OK" @ok="changeReferancePn"
             ref="RefPnModal" title="Reference PN"
             button-size="sm">
      <div>Please key in one PN.</div>
      <div class="header-col validate">
        <div>Reference PN<span class="text-danger pl-1">*</span></div>
        <div>
          <input type="text" class="form-control form-control-sm" required
                 v-model="refPnObj.pn" :class="{'is-invalid': _.get(refPnObj, 'state', false)}" />
          <div class="invalid-feedback">Please enter PN</div>
        </div>
      </div>
    </b-modal>

    <b-modal centered :ok-title="reasonObj.okTitle" @ok="reasonOK"
             :cancel-title="reasonObj.cancelTitle"
             :ok-variant="reasonObj.variant"
             :title-class="[`text-${reasonObj.variant || 'primary'}`]"
             ref="ReasonModal" :title="reasonObj.title"
             button-size="sm">
      <div>{{ reasonObj.message1 }}</div>
      <div>{{ reasonObj.message2 }}</div>
      <div>
        <gtc-textarea v-model="reasonObj.reason" :class="{'is-invalid': _.get(reasonObj, 'state', false)}" />
        <div class="invalid-feedback">{{ reasonObj.invalidFeedback }}</div>
      </div>
    </b-modal>

    <b-modal centered :ok-title="autoApproveObj.okTitle" @ok="autoApproveOK"
             :cancel-title="autoApproveObj.cancelTitle"
             :ok-variant="autoApproveObj.variant"
             :title-class="[`text-${autoApproveObj.variant || 'primary'}`]"
             ref="AutoApproveModal" :title="autoApproveObj.title"
             button-size="sm">
      <div>{{ autoApproveObj.message1 }}</div>
      </br>
      <div>{{ autoApproveObj.message2 }}</div>
    </b-modal>
    <!--#endregion "-->

    <div v-if="nreData">
      <div class="row px-4 py-2 bg-gray-950 text-white align-items-center fixed-top" style="height: 4.286rem;">
        <div class="col-auto h2 mb-0">{{ _.get(nreData,'page_object.basic_info_review.account','') }}</div>
        <div v-if="adminRole()">
          <button type="button"
                  @click="collapseSignflow()"
                  class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                  v-b-tooltip.hover.right title="Collapse tow view signflow"></button>
        </div>
        <div class="col-auto ml-auto d-flex align-items-center">

          <template v-if="currency">
            <div class="h5 mb-0 pr-1">Currency :</div>
            <div class="h5 mb-0" v-if="isETOSELECT">
              <template v-if="currencyDisabled || _.get(nreData,'action_disabled', true)">
                {{ currency }}
              </template>
              <template v-else>
                <b-form-select v-model="currency"
                               :options="etoSectorCurrencyOptions" size="sm"
                               @change="onCurrencyChanged"></b-form-select>
              </template>
            </div>
            <div v-else>
              <!-- ALLOW CURRENCY DROPDOWN LIST -->
              <template v-if="currencyDisabled || _.get(nreData,'action_disabled', true)">
                {{ currency }}
              </template>
              <template v-else>
                <b-form-select v-model="currency" :options="currencyOptions" size="sm" @change="onCurrencyChanged"></b-form-select>
              </template>
              <!--DISABLE CURRENCY DROPDOWN LIST
                <template>{{ currency }}</template>
            -->
            </div>
            <div class="bg-white mx-4" style="width:1px; height: 25px;"></div>
          </template>
          <div>
            <div class="font-weight-bold h5 mb-0">


              {{$route.name}}

            </div>
            <div :class="[stageStatusTimeClass]" class="h6 mb-0">{{stageStatusTimeTitle}} Time：{{ _.get(nreData, 'page_object.basic_info_review.last_update_date', null) | dateTimeFormat }}</div>
          </div>
        </div>
      </div>
      <div class="p-4">

        <div v-if="!currency" class="position-absolute d-flex" style="left: 0;right: 0;top: 4.286rem;bottom: 0;">
          <div class="m-auto" style="min-width: 15rem">
            <div v-if="_.get(nreData,'page_object.ref_skus',[]).length === 0" class="h3 text-danger">
              Missing referance SKU, please contact system administrator. Alice Lee: alice.cy.lee@getac.com.tw
            </div>
            <template v-else>
              <div class="h4">Currency</div>
              <b-form-select v-model="currencyTmp" :options="currencyOptions"></b-form-select>
              <button type="button" class="btn btn-primary mt-2 btn-block" :disabled="_.trim(currencyTmp) === ''" @click="setCurrency">Next</button>
            </template>
          </div>
        </div>

        <!--#region -- Router View ---->
        <router-view v-else
                     ref="child"
                     :stageNumber="stageNumber"
                     :createFunction="createFunction"
                     :skuItem="skuItem"
                     :aliveQuoteTypes="aliveQuoteTypes"
                     :currencyRate="currencyRate"
                     :currencySign="currencySign"
                     :readOnly="readOnly"
                     :pocWordingES="pocWordingES"
                     :mpWordingES="mpWordingES"
                     :pocWordingHQ="pocWordingHQ"
                     :mpWordingHQ="mpWordingHQ"
                     :pocWordingGRO="pocWordingGRO"
                     :mpWordingGRO="mpWordingGRO"
                     :priceReadOnly="priceReadOnly"
                     :isSubmitted="isSubmitted"
                     :isETOSELECT="isETOSELECT"
                     :etoSectorSite="etoSectorSite"
                     :loginUser="loginUser"
                     :data="$data"
                     :serverEnv="serverEnv"
                     :createBy="createBy"
                     :quoteItemsMapping="quoteItemsMapping"
                     :gpMpUnit="gpMpUnit"
                     :gpPocUnit="gpPocUnit"
                     :gpMpUnitWithNreAmortizationQuantity="gpMpUnitWithNreAmortizationQuantity"
                     :mailMessagePreview="mailMessagePreview"
                     :showReasonSection="showReasonSection"
                     @adminRole="adminRole"
                     @validateComments="validateComments"
                     @reload="reload"
                     @checkStatusForReasonDetail="checkStatusForReasonDetail"
                     @resetLeadTimeNotice="resetLeadTimeNotice"
                     @save="saveData"
                     @submit="submitData"
                     @autoApprove="autoApproveData"
                     @approve="approveData"
                     @withdraw="withdrawData"
                     @reject="rejectData"
                     @return="returnData"
                     @defer="deferData"
                     @conditionalApprove="conditionalApproveData"
                     @cancelNre="projectCancelData"
                     @kickOff="kickOffData"
                     @changeRefPn="showRefPnModal"
                     @substitute="showSubstituteModal"
                     @pocRequiredChange="pocRequiredChange"
                     @refreshQuoteItem="refreshQuoteItem"
                     @refreshQuoteItems="refreshQuoteItems"
                     @quoteItemModal="showQuoteItemModal"
                     @removeQuoteItem="removeQuoteItemToServer"
                     @uploadProjectProposalFile="uploadProjectProposalFile"
                     @uploadReferenceFile="uploadReferenceFile"
                     @deleteProjectProposalFile="deleteProjectProposalFile"
                     @deleteReferenceFile="deleteReferenceFile"
                     @uploadFile="uploadFile"
                     @deleteFile="deleteFile"
                     @getFile="getFile"
                     @getMpsQty="getMpsQty"/>
        <!--#endregion -->

      </div>
    </div>
  </div>
</template>
<script>
  import * as moment from 'moment/moment';
  export default {
    name: 'nre-page',
    props: {
      stageKey: {
        type: String,
        default: ''
      },
      stageApiBase: {
        type: String,
        default: ''
      },
      stageApiName: {
        type: String,
        default: ''
      },
      currencyDisabled: {
        type: Boolean,
        default: true
      }
    },
    data: () => {
      return {
        showReasonSection: false,
        pocWordingES: 'PoC Cost',
        mpWordingES: 'MP Cost',
        pocWordingHQ: 'PoC GRO Cost',
        mpWordingHQ: 'MP GRO Cost',
        pocWordingGRO: 'PoC Sales Price',
        mpWordingGRO: 'MP Sales Price',

        currencyTmp: null,
        nreData: null,
        tmpData: null,
        currency: null,
        etoSectorCurrencyOptions: [
          { value: "GUSA(USD)", text: "GUSA(USD)" },
          { value: "WW (USD)", text: "WW (USD)" },
          { value: "EU (EUR)", text: "EU (EUR)" }
        ],
        currencyRates: {
          "GUSA(USD)": 1,
          "WW (USD)": 1,
          "EU (GBP)": null,
          "EU (EUR)": null,
          "EU (AUD)": null,
          "GML (CNY)": null,
        },
        currencyOptions: [
          { value: "GUSA(USD)", text: "GUSA(USD)" },
          { value: "WW (USD)", text: "WW (USD)" },
          { value: "EU (GBP)", text: "EU (GBP)" },
          { value: "EU (EUR)", text: "EU (EUR)" },
          { value: "EU (AUD)", text: "EU (AUD)" },
          { value: "GML (CNY)", text: "GML (CNY)" },

        ],
        currencySigns: {
          "GUSA(USD)": '$',
          "WW (USD)": '$',
          "EU (GBP)": '£',
          "EU (EUR)": '€',
          "EU (AUD)": '$',
          "GML (CNY)": '¥'
        },
        projectProposalFileSetting: [],
        referenceFilesSetting: [],
        customizeQuoteItemsSetting: [],
        mailGroupSetting: [],
        kickoffFilesSetting: [],
        quoteTypes: [
          'POC',
          'POC NRE',
          'POC Addition Cost',
          'MP',
          'MP NRE',
          'MP Addition Cost'
        ],
        refPnObj: {},
        quoteItemObj: {
          action: null,
          sales_force_opty: null,
          ftie_id: null,
          sku_id: null,
          quote_type: null,
          qty: null,
          qtyMax: 1,
          sku_description: null,
          customization_description: null,
          ticket_type: null,
        },
        substituteObj: {},
        reasonObj: {},
        autoApproveObj: {},
      };
    },
    created() {
      let self = this;

      let callback = () => {
        self.loadProjectProposalFileSetting();
        self.loadReferenceFilesSetting();
        self.loadCustomizeQuoteItemsSetting();
        self.loadKickoffFilesSetting();

        if (!self.readOnly && self.includeStages(['10', '20'])) {
          self.loadRates();

          if (!self.readOnly)
            self.loadEsPmWatch();
        }

        else if (self.stageNumber === '30') {
          self.loadHqSalesWatch();
        }

        else if (self.stageNumber === '40') {
          self.loadMailGroupSetting();
          self.loadSaHeadWatch()
        }

        //#region Add refreshquote if not readonly
        // if (!self.readOnly) {
        //   self.refreshQuoteItems();
        // }

        //endregion

        //#region 未儲存提示

        $(window).on('beforeunload', function () {
          if (!self.readOnly && !self.includeStages('90') && JSON.stringify(self.nreData) !== JSON.stringify(self.tmpData)) {
            return "You have made changes on this page that you have not yet confirmed.\nIf you navigate away from this page you will lose your unsaved changes";
          }
        });

        //#endregion

      };

      self.reload(callback);

    },
    computed: {
      stageNumber() {
        return this.stageKey.substring(6);
      },
      createFunction() {
        let self = this;
        switch (self.stageKey) {
          case 'stage-10':
            return 'ES PM';
          case 'stage-20':
            return 'ES PM Leader';
          case 'stage-30':
            return 'HQ Sales Review';
          case 'stage-40':
            return 'SA Head Review';
          case 'stage-50':
            return 'GRO RSM Review';
          case 'stage-60':
            return 'GRO Sales Director';
          case 'stage-65':
            return 'GRO GM Confirmation';
          case 'stage-70':
            return 'GRO SA Head Confirmation';
          case 'stage-80':
            return 'GTC Sales Conformation';
          case 'stage-90':
            return 'Estimation ESPM Kickoff';
          default:
            return '';
        }
      },
      skuItem() {
        return _.get(this.nreData, 'page_object.ref_skus[0]', {});
      },
      readOnly() {
        return _.get(this.nreData, 'action_disabled', true);
      },
      priceReadOnly() {
        return true;
      },
      isSubmitted() {
        return _.get(this.nreData, 'check_submit', false);
      },
      isETOSELECT() {
        if (_.get(this.nreData, 'page_object.basic_info_review.ticket_type', null) === 'ETO Sector SKU'
          && _.get(this.nreData, 'page_object.basic_info_review.eto_sector_sku', null) !== null)
        {
          return true;
        } else {
          return false
        }
      },
      etoSectorSite() {
        let self = this;
        let selectedEquoteSitesTmp = null;
        if (self.isETOSELECT) {
          try {
            //_.get(this.nreData, 'page_object.basic_info_review.eto_sector_sku.equote_site_selected_list', null)
            if (_.get(self.nreData, 'page_object.basic_info_review.eto_sector_sku.equote_site_selected_list', null) !== null) {
              var i;
              selectedEquoteSitesTmp = [];
              for (i = 0; i < _.get(self.nreData, 'page_object.basic_info_review.eto_sector_sku.equote_site_selected_list', null).length; i++) {
                if (self.nreData.page_object.basic_info_review.eto_sector_sku.equote_site_selected_list[i] !== null) {
                  selectedEquoteSitesTmp.push({ value: self.nreData.page_object.basic_info_review.eto_sector_sku.equote_site_selected_list[i], text: self.nreData.page_object.basic_info_review.eto_sector_sku.equote_site_selected_list[i] })
                }
              }
              return selectedEquoteSitesTmp;
            }
            else {
              return selectedEquoteSitesTmp;
            }
          }
          catch (err) {
            console.log("err happen in build etoSectorSite");
            //console.log(etoSectorSite);
            return selectedEquoteSitesTmp;
          }
        }
      },
      loginUser() {
        return _.get(this.$store, 'state.username', null);
      },
      serverEnv() {
        return _.get(this.$store, 'state.env', null);
      },
      createBy() {
        return _.get(this.nreData, 'owner', null);
      },
      currencyRate() {
        return this.currencyRates[this.currency];
      },
      currencyRateNreData() {
        let tmpCurrency = _.get(_.first(_.get(this.nreData, 'page_object.ref_skus', [null])), 'region', null);
        if (tmpCurrency === null)
          return null
        else
          return this.currencyRates[tmpCurrency];
      },
      currencySign() {
        return this.currencySigns[this.currency];
      },
      pocRequired() {
        let self = this;
        if (_.includes(['10', '20'], self.stageNumber)) {
          return self.nreData.page_object.nre_estimation_from_espm.poc_required === 'Y';
        }
        else {
          return self.nreData.page_object.nre_estimation_curr_stage.poc_required === 'Y';
        }
      },
      pocChosen() {
        let self = this;
        if (_.includes(['10', '20'], self.stageNumber)) {
          return (self.nreData.page_object.nre_estimation_from_espm.poc_required === 'Y'
            || self.nreData.page_object.nre_estimation_from_espm.poc_required === 'N');
        }
        else {
          return (self.nreData.page_object.nre_estimation_curr_stage.poc_required === 'Y'
            || self.nreData.page_object.nre_estimation_curr_stage.poc_required === 'N');
        }
      },
      aliveQuoteTypes() {
        let self = this;
        if (self.nreData === null) return null;

        let quoteTypes = JSON.parse(JSON.stringify(self.quoteTypes));
        let used = _.map(self.nreData.page_object.quote_items, 'quote_type');
        //console.log("aliveQuoteTypes used==");
        //console.log(used);
        if (_.includes(used, 'POC')) {
          _.remove(used, function (e) {
            return e === 'POC';
          });
        }

        if (_.includes(used, 'POC Addition Cost')) {
          _.remove(used, function (e) {
            return e === 'POC Addition Cost';
          });
        }

        //console.log(used);


        let output = _.xor(quoteTypes, used);
        if (!self.pocRequired || self.isETOSELECT) {
          output = _.filter(output, item => { return !item.match(/^POC/) });
        }
        if (_.trim(_.get(self.quoteItemObj, 'quote_type', '')) !== '') {
          output.splice(0, 0, self.quoteItemObj.quote_type);
          output = _.uniq(output);
        }
        return output;
      },
      pricePropertyPath() {
        return [
          'page_object.nre_estimation_from_espm.labor_cost.development.poc_cost',
          'page_object.nre_estimation_from_espm.labor_cost.development.mp_cost',
          'page_object.nre_estimation_from_espm.labor_cost.verification.poc_cost',
          'page_object.nre_estimation_from_espm.labor_cost.verification.mp_cost',
          'page_object.nre_estimation_from_espm.test_sample.poc_cost',
          'page_object.nre_estimation_from_espm.test_sample.mp_cost',
          'page_object.nre_estimation_from_espm.job_cost.tooling_fee.poc_cost',
          'page_object.nre_estimation_from_espm.job_cost.tooling_fee.mp_cost',
          'page_object.nre_estimation_from_espm.job_cost.pcb_fee.poc_cost',
          'page_object.nre_estimation_from_espm.job_cost.pcb_fee.mp_cost',
          'page_object.nre_estimation_from_espm.job_cost.test_jig.poc_cost',
          'page_object.nre_estimation_from_espm.job_cost.test_jig.mp_cost',
          'page_object.nre_estimation_from_espm.job_cost.outsource_fee.poc_cost',
          'page_object.nre_estimation_from_espm.job_cost.outsource_fee.mp_cost',
          'page_object.nre_estimation_from_espm.job_cost.job_cost_others.poc_cost',
          'page_object.nre_estimation_from_espm.job_cost.job_cost_others.mp_cost',
          'page_object.nre_estimation_from_espm.regulation.emc.poc_cost',
          'page_object.nre_estimation_from_espm.regulation.emc.mp_cost',
          'page_object.nre_estimation_from_espm.regulation.safety.poc_cost',
          'page_object.nre_estimation_from_espm.regulation.safety.mp_cost',
          'page_object.nre_estimation_from_espm.regulation.environment.poc_cost',
          'page_object.nre_estimation_from_espm.regulation.environment.mp_cost',
          'page_object.nre_estimation_from_espm.regulation.regulation_others.poc_cost',
          'page_object.nre_estimation_from_espm.regulation.regulation_others.mp_cost',
          'page_object.nre_estimation_from_espm.others.poc_cost',
          'page_object.nre_estimation_from_espm.others.mp_cost',
          // 'page_object.unit_estimation_from_espm.demand_quantity.poc_cost',
          // 'page_object.unit_estimation_from_espm.demand_quantity.mp_cost',
          'page_object.unit_estimation_from_espm.cost_base_unit.poc_cost',
          'page_object.unit_estimation_from_espm.cost_base_unit.mp_cost',
          'page_object.unit_estimation_from_espm.deduct_cost.poc_cost',
          'page_object.unit_estimation_from_espm.deduct_cost.mp_cost',
          'page_object.unit_estimation_from_espm.additional_material_cost.poc_cost',
          'page_object.unit_estimation_from_espm.additional_material_cost.mp_cost',
          'page_object.unit_estimation_from_espm.additional_mva_cost.poc_cost',
          'page_object.unit_estimation_from_espm.additional_mva_cost.mp_cost'
        ];
      },
      stageStatusTimeTitle() {
        var self = this;
        let lastUpdateStatus = _.get(self.nreData, 'page_object.basic_info_review.last_update_status', null);
        const statusMap = {
          "W": "Last Edited",
          "Waiting": "Last Edited",
          "Ongoing": "Last Edited",
          "Completed": self.includeStages(['65']) ? "Approved" : "Submmited",
          "Completed_": self.includeStages(['65']) ? "Conditional Approved" : "Submmited",
          "Submitted": "Submitted",
          "S": "Submitted",
          "Rejected": "Rejected",
          "Returned": "Returned",
          "Deferred": "Deferred",
          "Canceled": "Canceled",
        };
        if (lastUpdateStatus in statusMap) {
          return statusMap[lastUpdateStatus];
        }
        return '';
      },
      stageStatusTimeClass() {
        var self = this;
        let lastUpdateStatus = _.get(self.nreData, 'page_object.basic_info_review.last_update_status', null);
        const statusBackgroundColorMap = {
          "Rejected": "bg-danger",
          "Deferred": "bg-danger",
          "Returned": "bg-danger",
          "Canceled": "bg-danger",
          "Completed_": self.includeStages(['65']) ? "bg-primary" : "",
        };
        if (lastUpdateStatus in statusBackgroundColorMap) {
          return statusBackgroundColorMap[lastUpdateStatus];
        }
        return '';
      },
      quoteItemsMapping() {
        let self = this;
        var groups = _.groupBy(this.nreData.page_object.quote_items, function (n) {
          return n.quote_type + " ++ " + n.qty;
        });
        let data = _.map(groups, items => {
          let head = _.first(_.orderBy(items, item => {
            switch (item.create_function) {
              case 'ES PM': return 1;
              case 'ES PM Leader': return 2;
              case 'HQ Sales Review': return 3;
              case 'SA Head Review': return 4;
              default: return 5;
            }
          }, ['asc']));

          let details = items;

          if (!self.includeStages(['10', '20', '30', '40', '80', '90'])) {
            details = _.filter(details, item => { return item.create_function !== 'ES PM' && item.create_function !== 'ES PM Leader'; })
          }
          details = _.orderBy(details, ['uni_id'], ['asc']);

          let output = {
            ...head,
            details: details
          };
          return output;
        });
        //console.log("data");
        //console.log(data);

        /*
        let dataOld = _.map(_.groupBy(this.nreData.page_object.quote_items, 'quote_type'), items => {

          let head = _.first(_.orderBy(items, item => {
            switch (item.create_function) {
              case 'ES PM': return 1;
              case 'ES PM Leader': return 2;
              case 'HQ Sales Review': return 3;
              case 'SA Head Review': return 4;
              default: return 5;
            }
          }, ['asc']));

          let details = items;

          if (!self.includeStages(['10', '20', '30', '40', '80', '90'])) {
            details = _.filter(details, item => { return item.create_function !== 'ES PM' && item.create_function !== 'ES PM Leader'; })
          }
          details = _.orderBy(details, ['uni_id'], ['asc']);

          let output = {
            ...head,
            details: details
          };
          return output;
        });
        */

        return _.orderBy(data, ['quote_type'], ['asc']);

      },
      gpMpUnit() {

        let stage = _.sum([
          _.get(this.nreData.page_object, 'unit_estimation_curr_stage.cost_base_unit.mp_cost', 0),
          _.get(this.nreData.page_object, 'unit_estimation_curr_stage.additional_material_cost.mp_cost', 0),
          _.get(this.nreData.page_object, 'unit_estimation_curr_stage.additional_mva_cost.mp_cost', 0)
        ]);
        let last_stage = 0
        if (this.includeStages(['40', '70'])) {
          last_stage = _.sum([
            _.get(this.nreData.page_object, `unit_estimation_hq_sales.cost_base_unit.mp_cost`, 0),
            _.get(this.nreData.page_object, `unit_estimation_hq_sales.additional_material_cost.mp_cost`, 0),
            _.get(this.nreData.page_object, `unit_estimation_hq_sales.additional_mva_cost.mp_cost`, 0)
          ]);
        } else {
          last_stage = _.sum([
            _.get(this.nreData.page_object, `unit_estimation_from_espm.cost_base_unit.mp_cost`, 0),
            _.get(this.nreData.page_object, `unit_estimation_from_espm.additional_material_cost.mp_cost`, 0),
            _.get(this.nreData.page_object, `unit_estimation_from_espm.additional_mva_cost.mp_cost`, 0),
            _.get(this.nreData.page_object, `unit_estimation_from_espm.deduct_cost.mp_cost`, 0) * -1
          ]);
        }

        if (stage === 0) return 0;
        return _.round((stage - last_stage) / stage * 100, 2);

      },
      gpPocUnit() {

        let name = 'unit_estimation_from_espm';
        if (this.includeStages(['40', '70'])) name = 'unit_estimation_hq_sales';

        let stage = _.get(this.nreData.page_object, 'unit_estimation_curr_stage.total_cost.poc_cost', 0);
        let espm = _.get(this.nreData.page_object, `${name}.total_cost.poc_cost`, 0);

        if (stage === 0) return 0;
        return _.round((stage - espm) / stage * 100, 2);

      },
      gpMpUnitWithNreAmortizationQuantity() {

        let name = 'unit_estimation_from_espm';
        if (this.includeStages(['40', '70'])) name = 'unit_estimation_hq_sales';

        let stage = _.get(this.nreData.page_object, 'unit_estimation_curr_stage.total_cost.mp_cost', 0);
        let espm = _.get(this.nreData.page_object, `${name}.total_cost.mp_cost`, 0);

        if (stage === 0) return 0;
        return _.round((stage - espm) / stage * 100, 2);
      },
      quoteTableHtml() {
        return `
<style>
  .outlook-table {
    font-family: Arial;
    border-collapse: collapse;
    border: 1px solid #dee2e6;
  }
  .outlook-table * {
    font-family: Arial;
  }
  .outlook-table td {
    font-size: 10pt;
    border: 1px solid #dee2e6;
    padding-left: 5px;
    padding-right: 5px;
  }
  .outlook-table th{
    white-space: nowrap;
    font-weight: bold;
    font-size: 10pt;
    border: 1px solid #dee2e6;
    padding-left: 5px;
    padding-right: 5px;
  }
</style>
<table class='outlook-table'>
  <tr style='background-color: #d7d7d7;'>
    <th>Type</th>
    <th>Salesforce Opportunity</th>
    <th>FTIE ID</th>
    <th>ETO NRE</th>
    <th>SKU ID</th>
    <th style='text-align: left'>Customization Description</th>
    <th>QTY</th>
    <th>Selling Price</th>
  </tr>
  [$quote_items$]
</table>
`;
      },
      mailMessagePreview() {
        let self = this;
        let template = _.trim(_.get(self.nreData, 'page_object.mail_template', ''));
        if (template === '') return '';

        let output = template;

        //#region -- variables --

        //#region -- recipient --
        let mailGroupSelected = _.find(self.nreData.page_object.mail_group, { chosen: true });
        let recipient = '';
        if (!_.isNil(mailGroupSelected)) {
          recipient = _.flatten(_.map(mailGroupSelected, role => {
            return _.map(role, member => { return _.get(member, 'member_name', ''); });
          }));
          recipient = _.join(_.sortBy(_.union(_.filter(recipient, item => { return item.length !== 0; }))), ', ');
        }
        if (recipient === '') recipient = 'No Body';
        //#endregion
         let cols = [
          self.nreData.page_object.nre_estimation_curr_stage.labor_cost.mp_cost,
          self.nreData.page_object.nre_estimation_curr_stage.test_sample.mp_cost,
          self.nreData.page_object.nre_estimation_curr_stage.job_cost.mp_cost,
          self.nreData.page_object.nre_estimation_curr_stage.regulation.regulation_others.mp_cost,
          self.nreData.page_object.nre_estimation_curr_stage.total_cost.mp_cost
        ];
        let saHeadTotalMpNreResult = _.round(_.sum(cols), 2);

        let totalMpCost = _.get(self.nreData.page_object, 'nre_estimation_curr_stage.total_cost.mp_cost', 0);
        let additionalMpCost = _.round(_.sum([
          _.get(self.nreData.page_object, 'unit_estimation_curr_stage.additional_material_cost.mp_cost', 0),
          _.get(self.nreData.page_object, 'unit_estimation_curr_stage.additional_mva_cost.mp_cost', 0)
        ]), 2);
        let nreAmortizaitonCost = _.get(self.nreData.page_object, 'unit_estimation_curr_stage.nre_amortization.nre_amortization_cost', 0);

        let demand_quantity1 = _.get(self.nreData.page_object, 'unit_estimation_curr_stage.demand_quantity.mp_cost', 0);;
        let demand_quantity2 = _.get(self.nreData.page_object, 'unit_estimation_curr_stage.nre_amortization.nre_amortization_quantity', 0);
        let demand_quantity3 = _.get(self.nreData.page_object, 'unit_estimation_curr_stage.nre_amortization.nre_amortization_quantity', 0);

        let variables = {
          'recipient': recipient,
          'unit_estimation.total_mp_cost': self.$options.filters['comma'](saHeadTotalMpNreResult, 2),
          'unit_estimation_additional_mp_cost': self.$options.filters['comma'](additionalMpCost, 2),
          'unit_estimation_nre_amortization_cost': self.$options.filters['comma'](nreAmortizaitonCost, 2),
          'demand_quantity1': self.$options.filters['comma'](demand_quantity1, 2),
          'demand_quantity2': self.$options.filters['comma'](demand_quantity2, 0),
          'demand_quantity3': self.$options.filters['comma'](demand_quantity3, 0),
        };

        _.each(variables, (value, key) => {
          if (output.indexOf(`[$${key}$] [$${key}$]`) > -1) {
            output = output.replace(`[$${key}$] [$${key}$]`, value);
          }
        });

        //#endregion

        //#region -- quote_items --

        if (output.indexOf('[$quote_items$] [$quote_items$]') > -1) {
          let quoteTableHtml = self.quoteTableHtml;

          let items = '';
          let comma = self.$options.filters["comma"];
          _.forEach(self.quoteItemsMapping, item => {
            items += `<tr>
    <td>${item.quote_type}</td>
    <td>${item.sales_force_opty}</td>
    <td>${item.ftie_id}</td>
    <td>${item.nre_id}</td>
    <td>${item.sku_id}</td>
    <td>${item.description}</td>
    <td style='text-align: right'>${comma(item.qty, 0)}</td>
    <td style='text-align: right'>${comma(item.selling_price || 0)}</td>
</tr>`;

          });
          quoteTableHtml = quoteTableHtml.replace('[$quote_items$]', items);

          output = output.replace('[$quote_items$] [$quote_items$]', quoteTableHtml);
        }

        //#endregion

        self.$set(self.nreData.page_object, 'mail_template_exclude_regexp', output);

        return output;
      },
    },
    /* useless , because in the mounted area, nreData is always null (not reload the page yet, use reload method will be just fine)
    mounted: function () {
      if (this.nreData) {
        let ref_skus = _.get(this.nreData, 'page_object.ref_skus', [{ region: '' }]);
        if (ref_skus.length > 0 && _.first(ref_skus).region !== '') {
          this.currency = _.first(this.nreData.page_object.ref_skus).region;
        }
      }
    },
    */
    methods: {
      /**
       *      etoSectorEquoteSiteUpdate() {
        let self = this;
        var i;
        var siteSelected = [];
        if (self.etoSectorSite !== null && self.etoSectorSite.length > 0) {
          for (i = 0; i < self.etoSectorSite.length; i++) {
            siteSelected.push(self.etoSectorSite[i]['value'])
          }
        }
        console.log("siteSelected in NrePage:");
        console.log(siteSelected);
        let requestData = {
          ftie_id: self.nreData.page_object.basic_info_review.ftie_id,
          nre_id: self.nreData.page_object.basic_info_review.nre_id,
          create_by: self.loginUser,
          username: self.loginUser,
          edit_field: 'equote_site',
          input_info: siteSelected
        };
        self.$axios
          .post(self.$root.baseUrl + '/eto-sector-sku/update/', requestData)
          .then(res => {
            let result = res.data;
            let result_obj = null;
            if (res.status === 200) {
              result.save_success = JSON.parse(result.save_success);
              result_obj = result.save_success
            } else if (result.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          }).finally(() => {
            console.log("finish @etoSectorEquoteSite");
          });
      },
       * */

      //#region -- Set CurrencyTmp to Currency --
      setCurrency() {
        if (_.trim(this.currencyTmp) !== '') {

          let ref_skus = _.get(this.nreData, 'page_object.ref_skus', []);
          if (ref_skus.length > 0) {
            _.first(ref_skus).region = this.currencyTmp;
            this.applyCurrencyChange(true);
          }
          else {
            this.$message.error('Missing referance SKU, please contact system administrator. Alice Lee: alice.cy.lee@getac.com.tw');
          }
        }
      },
      //#endregion

      //#region -- Private --
      includeStages(stages) {
        return _.includes(stages, this.stageNumber)
      },
      //#endregion

      //#region -- Permission --
      checkLoggedIn() {
        let self = this;
        let result = true;
        if (_.trim(self.loginUser) === '') result = false;
        if (!_.get(self.nreData, 'permission', false)) result = false;

        if (!result) self.$router.push("/");
        self.checkStatusForReasonDetail();
        return result;
      },
      //#endregion

      //#region -- Page Init --

      //#region -- Table Settings --

      loadProjectProposalFileSetting() {
        let self = this;
        self.projectProposalFileSetting = [];
        self.projectProposalFileSetting.push({ key: 'file_name', label: 'File Name', thClass: '', tdClass: 'text-truncate' });
        self.projectProposalFileSetting.push({ key: 'file_size', label: 'File Size', thClass: '', thStyle: { width: '6rem' } });
        self.projectProposalFileSetting.push({ key: 'update_time', label: 'Update Time', thClass: '', thStyle: { width: '10rem' } });
        if (!self.readOnly && self.includeStages(['10', '20']))
          self.projectProposalFileSetting.push({ key: 'delete', label: '', thClass: '', thStyle: { width: '2.143rem' }, tdClass: 'p-0' });

      },
      loadReferenceFilesSetting() {
        let self = this;
        self.referenceFilesSetting = [];
        self.referenceFilesSetting.push({ key: 'file_name', label: 'File Name', thClass: '', tdClass: 'text-truncate' });
        self.referenceFilesSetting.push({ key: 'file_size', label: 'File Size', thClass: '', thStyle: { width: '6rem' } });
        self.referenceFilesSetting.push({ key: 'update_time', label: 'Update Time', thClass: '', thStyle: { width: '10rem' } });
        if (!self.readOnly && self.includeStages(['10', '20']))
          self.referenceFilesSetting.push({ key: 'delete', label: '', thClass: '', thStyle: { width: '2.143rem' }, tdClass: 'p-0' });
      },
      loadCustomizeQuoteItemsSetting() {
        let self = this;
        let moneyFormatter = (value, key, item) => {
          return self.$options.filters['comma'](value, 2);
        };

        self.customizeQuoteItemsSetting = [];
        self.customizeQuoteItemsSetting.push({ key: 'quote_type', label: 'Type', thClass: 'align-middle', thStyle: { width: '1px' }, tdClass: 'text-nowrap' });
        self.customizeQuoteItemsSetting.push({ key: 'sales_force_opty', label: 'Salesforce Opportunity', thClass: 'text-nowrap align-middle' });
        self.customizeQuoteItemsSetting.push({ key: 'ftie_id', label: 'FTIE ID', thClass: 'text-nowrap align-middle', thStyle: { width: '1px' } });
        self.customizeQuoteItemsSetting.push({ key: 'nre_id', label: 'ETO NRE', thClass: 'text-nowrap align-middle', thStyle: { width: '1px' } });
        self.customizeQuoteItemsSetting.push({ key: 'sku_id', label: 'Customization SKU ID', thClass: 'text-nowrap align-middle', thStyle: { width: '1px' } });
        self.customizeQuoteItemsSetting.push({ key: 'description', label: 'Customization Description', thClass: 'align-middle' });
        self.customizeQuoteItemsSetting.push({ key: 'qty', label: 'QTY', thClass: 'text-nowrap align-middle', thStyle: { width: '1px' }, tdClass: 'text-right' });

        if (self.includeStages(['10', '20', '30', '40', '80', '90'])) self.customizeQuoteItemsSetting.push({ key: 'amortize_qty', label: 'Amortize Qty', thClass: 'text-nowrap align-middle', thStyle: { width: '7rem' }, tdClass: 'text-center' });

        if (self.includeStages(['10', '20', '30', '80', '90'])) self.customizeQuoteItemsSetting.push({ key: 'hq_cost', label: 'HQ Cost', thClass: 'text-nowrap align-middle', thStyle: { width: '6.5rem' }, tdClass: 'text-right' });

        if (self.includeStages(['30', '40', '80', '90'])) self.customizeQuoteItemsSetting.push({ key: 'gro_cost', label: 'GRO Cost', thClass: 'text-nowrap align-middle', thStyle: { width: '6.5rem' }, tdClass: 'text-right' });
        if (self.includeStages(['40', '50', '60', '65', '70', '80', '90']))
          self.customizeQuoteItemsSetting.push({ key: 'selling_price', label: 'Selling Price', thClass: 'text-nowrap align-middle', thStyle: { width: '7rem' }, tdClass: 'text-right', formatter: moneyFormatter });

        if (!self.readOnly && self.includeStages(['10', '20']))
          self.customizeQuoteItemsSetting.push({ key: 'action', label: '', thClass: 'align-middle', thStyle: { width: '4.58rem' }, tdClass: 'p-0 text-center' });

        if (self.includeStages(['80', '90'])) self.customizeQuoteItemsSetting.push({ key: 'quote_to_gro', label: 'Submit to GRO', thClass: 'align-middle text-center', thStyle: { width: '5rem' }, tdClass: 'text-center' });

      },
      loadMailGroupSetting() {
        let self = this;
        self.mailGroupSetting = [];
        self.mailGroupSetting.push({ key: 'chosen', label: '', thClass: 'align-middle', thStyle: { width: '1px' }, tdClass: 'text-nowrap' });
        self.mailGroupSetting.push({ key: 'group_name', label: 'Mail Group Name', thClass: 'align-middle', thStyle: {}, tdClass: '' });
        self.mailGroupSetting.push({ key: 'site', label: 'Site', thClass: 'align-middle', thStyle: { width: 'auto' }, tdClass: 'text-nowrap' });
        self.mailGroupSetting.push({ key: 'rsm', label: 'RSM', thClass: 'align-middle', thStyle: { width: 'auto' }, tdClass: 'text-nowrap' });
        self.mailGroupSetting.push({ key: 'sales_director', label: 'Sales Director', thClass: 'align-middle', thStyle: { width: 'auto' }, tdClass: 'text-nowrap' });
        self.mailGroupSetting.push({ key: 'inside_sales', label: 'Inside Sales', thClass: 'align-middle', thStyle: { width: 'auto' }, tdClass: 'text-nowrap' });
        self.mailGroupSetting.push({ key: 'hq_sales', label: 'HQ Sales', thClass: 'align-middle', thStyle: { width: 'auto' }, tdClass: 'text-nowrap' });
        self.mailGroupSetting.push({ key: 'sa_team', label: 'SA Team', thClass: 'align-middle', thStyle: { width: 'auto' }, tdClass: 'text-nowrap' });
        self.mailGroupSetting.push({ key: 'ofd', label: 'OFD', thClass: 'align-middle', thStyle: { width: 'auto' }, tdClass: 'text-nowrap' });
        self.mailGroupSetting.push({ key: 'gro_head', label: 'GRO Head', thClass: 'align-middle', thStyle: { width: 'auto' }, tdClass: 'text-nowrap' });
        self.mailGroupSetting.push({ key: 'others', label: 'Others', thClass: 'align-middle', thStyle: { width: 'auto' }, tdClass: 'text-nowrap' });
        if (!self.readOnly)
          self.mailGroupSetting.push({ key: 'action', label: '', thClass: 'align-middle', thStyle: { width: '1px' }, tdClass: 'text-nowrap' });
      },
      loadKickoffFilesSetting() {
        let self = this;
        self.kickoffFilesSetting = [];
        self.kickoffFilesSetting.push({ key: 'category', label: 'Category', thClass: '', tdClass: 'text-nowrap', thStyle: { width: '15rem' } });
        self.kickoffFilesSetting.push({ key: 'file_name', label: 'File Name', thClass: '', tdClass: '' });
        self.kickoffFilesSetting.push({ key: 'file_source', label: 'File Source', thClass: '', thStyle: { width: '10rem' }  });
        self.kickoffFilesSetting.push({ key: 'file_size', label: 'File Size', thClass: '', thStyle: { width: '6rem' } });
        self.kickoffFilesSetting.push({ key: 'update_time', label: 'Update Time', thClass: '', thStyle: { width: '10rem' } });
      },

      //#endregion -- Table Settings --

      loadRates() {
        let self = this;

        let time = moment().format('YYYY/MM/DD');
        let items = ['EU (GBP)', 'EU (EUR)', 'EU (AUD)', 'GML (CNY)'];

        eventHub.$emit('loading', true);

        self.$axios
          .all(items.map(item => {
            return self.$axios.post(`${self.$root.baseUrl}/stage-management/change-rate/`, { 'currency': item, 'create_date': time })
          }))
          .then(results => {
            _.each(results, (result, index) => {
              if (_.get(result, 'status', 0) == 200) {
                self.currencyRates[items[index]] = result.data['rate'];
              }
              else {
                this.$message.error(`Get Currency for ${items[index]} Failed!`);
              }
            });

            eventHub.$emit('loading', false);
          });

      },

      loadEsPmWatch() {
        let self = this;

        let fn = (newValue, oldValue) => {
          self.refreshQuoteItems();
        }

        self.$watch('nreData.page_object.nre_estimation_from_espm.total_cost.poc_cost', fn);
        self.$watch('nreData.page_object.nre_estimation_from_espm.total_cost.mp_cost', fn);
        self.$watch('nreData.page_object.unit_estimation_from_espm.total_cost.poc_cost', fn);
        self.$watch('nreData.page_object.unit_estimation_from_espm.total_cost.mp_cost', fn);
        self.$watch('nreData.page_object.unit_estimation_from_espm.additional_material_cost.mp_cost', fn);
        self.$watch('nreData.page_object.unit_estimation_from_espm.additional_mva_cost.mp_cost', fn);
        self.$watch('nreData.page_object.unit_estimation_from_espm.nre_amortization.nre_amortization_cost', fn);
        self.$watch('nreData.page_object.unit_estimation_from_espm.additional_material_cost.poc_cost', fn);
        self.$watch('nreData.page_object.unit_estimation_from_espm.additional_mva_cost.poc_cost', fn);
      },

      loadHqSalesWatch() {
        let self = this;

        let fn = (newValue, oldValue) => {
          self.refreshQuoteItems();
        }

        self.$watch('nreData.page_object.nre_estimation_curr_stage.total_cost.poc_cost', fn);
        self.$watch('nreData.page_object.nre_estimation_curr_stage.total_cost.mp_cost', fn);
        self.$watch('nreData.page_object.unit_estimation_curr_stage.total_cost.poc_cost', fn);
        self.$watch('nreData.page_object.unit_estimation_curr_stage.total_cost.mp_cost', fn);
        self.$watch('nreData.page_object.unit_estimation_curr_stage.additional_material_cost.mp_cost', fn);
        self.$watch('nreData.page_object.unit_estimation_curr_stage.additional_mva_cost.mp_cost', fn);
        self.$watch('nreData.page_object.unit_estimation_curr_stage.nre_amortization.nre_amortization_cost', fn);
        self.$watch('nreData.page_object.unit_estimation_curr_stage.additional_material_cost.poc_cost', fn);
        self.$watch('nreData.page_object.unit_estimation_curr_stage.additional_mva_cost.poc_cost', fn);
      },

      loadSaHeadWatch() {
        let self = this;

        let fn = (newValue, oldValue) => {
          self.refreshQuoteItems();
        }

        self.$watch('nreData.page_object.nre_estimation_curr_stage.labor_cost.poc_cost', fn);
        self.$watch('nreData.page_object.nre_estimation_curr_stage.labor_cost.mp_cost', fn);
        self.$watch('nreData.page_object.nre_estimation_curr_stage.test_sample.poc_cost', fn);
        self.$watch('nreData.page_object.nre_estimation_curr_stage.test_sample.mp_cost', fn);
        self.$watch('nreData.page_object.nre_estimation_curr_stage.job_cost.poc_cost', fn);
        self.$watch('nreData.page_object.nre_estimation_curr_stage.job_cost.mp_cost', fn);
        self.$watch('nreData.page_object.nre_estimation_curr_stage.regulation.regulation_others.poc_cost', fn);
        self.$watch('nreData.page_object.nre_estimation_curr_stage.regulation.regulation_others.mp_cost', fn);
        

        self.$watch('nreData.page_object.nre_estimation_curr_stage.total_cost.poc_cost', fn);
        self.$watch('nreData.page_object.nre_estimation_curr_stage.total_cost.mp_cost', fn);
        self.$watch('nreData.page_object.unit_estimation_curr_stage.total_cost.poc_cost', fn);
        self.$watch('nreData.page_object.unit_estimation_curr_stage.total_cost.mp_cost', fn);
        self.$watch('nreData.page_object.unit_estimation_curr_stage.additional_material_cost.mp_cost', fn);
        self.$watch('nreData.page_object.unit_estimation_curr_stage.additional_mva_cost.mp_cost', fn);
        self.$watch('nreData.page_object.unit_estimation_curr_stage.nre_amortization.nre_amortization_cost', fn);
        self.$watch('nreData.page_object.unit_estimation_curr_stage.additional_material_cost.poc_cost', fn);
        self.$watch('nreData.page_object.unit_estimation_curr_stage.additional_mva_cost.poc_cost', fn);
      },

      getLeadTimeNoticeTemplate() {
        /*
        return [
          '<p>',
          '1. If PoC required, PoC Lead-time will be <span data-field="PoC weeks" style="background-color: #fac51c;">__</span> weeks after PoC order (include PoC NRE) confirmed.<br>',
          '2. MP Lead-time will be <span data-field="MP weeks" style="background-color: #fac51c;">__</span> weeks after PoC and customer&#39;s order (include MP NRE) confirmed or HQ Sales inform to kickoff the project for MP.<br>',
          '3. The NRE quote does not include B2B warranty.<br>',
          '4. Limitation: (ex: Environmental/Functionality specification degraded..)<br>',
          '5. MOQ Quantity: (ex: minimum order quantity cause by some specific material&hellip;)<br>',
          '6. The POC sample is not fully validated by factory. So, the POC sample is not suitable for reliability tests.',
          '</p>'
        ].join('');*/
        let self = this;
        return self.nreData.page_object.lead_time_notice.note_text_default;
      },

      resetLeadTimeNotice() {
        let self = this;
        self.nreData.page_object.lead_time_notice.note_text = self.getLeadTimeNoticeTemplate();
      },

      //#endregion

      //#region -- Page Events --

      //#region -- SKU ID Substitute --

      showSubstituteModal() {
        let self = this;
        self.substituteObj = { skuId: null, state: false, errMsg: null };
        self.$refs['SubstituteModal'].show();
      },
      substituteSku(bvModalEvt) {
        let self = this;
        //console.log(bvModalEvt);

        bvModalEvt.preventDefault();

        self.substituteObj.state = _.trim(_.get(self.substituteObj, 'skuId', '')) === '';

        if (self.substituteObj.state === true) {
          self.substituteObj.errMsg = 'Please enter SKU ID';
          return;
        }
        else {

          let callback = () => {
            self.$nextTick(() => {
              self.$refs['SubstituteModal'].hide();
            });

          };

          self.changeSkuItem(self.substituteObj.skuId, callback);

        }
      },
      substituteSkuByCancel(bvModalEvt) {
        let self = this;
        //console.log(bvModalEvt);

        bvModalEvt.preventDefault();
        let callback = () => {
          self.$nextTick(() => {
            self.$refs['SubstituteModal'].hide();
          });

        };
        if (_.trim(_.get(self.substituteObj, 'skuId', '')) === '' || self.substituteObj.errMsg !== "Can't find this sku info. Please try another one!") {
          callback();
        } else {
          if (self.substituteObj.state === true) {
            self.changeSkuItem(self.substituteObj.skuId, callback);
          }
        }
      },
      changeSkuItem(skuId, callback) {
        let self = this;
        let urlFetch = `${self.$root.baseUrl}/stage-management/fetch-sku/`;
        let requestData = {
          create_by: self.createBy,
          username: self.loginUser,
          ftie_id: self.nreData.page_object.basic_info_review.ftie_id,
          nre_id: self.nreData.page_object.basic_info_review.nre_id,
          model_name: self.nreData.page_object.basic_info_review.nre_model,
          sku_id: skuId,
          region: self.currency,
          exchange_rate: self.currencyRates[self.currency]
        };

        eventHub.$emit('loading', true);
        self.$axios
          .post(urlFetch, requestData)
          .then(resRead => {
            //console.log(resRead);
            if (_.get(resRead, 'status', 0) !== 200) return;
            let data = resRead.data;
            data.ref_sku_object = _.first(JSON.parse(data.ref_sku_object));
            if (data.ref_sku_object['price_info']['cost_empty'] === false) {
              data.ref_sku_object['exchange_rate'] = `${self.currencyRate}:1`;
              self.saveSkuItem(data.ref_sku_object, callback);
            } else {
              // if ((trigger === 'cancel' && self.substituteObj.state === true) || trigger === 'applyCurrencyChange') {
              data.ref_sku_object['exchange_rate'] = `${self.currencyRate}:1`;
              self.substituteObj.state = true;
              self.substituteObj.errMsg = "Can't find this sku info. Please try another one!";
              let empty_callback = () => {self.$nextTick(() => {});};
              self.saveSkuItem(data.ref_sku_object, empty_callback);
            }

          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },
      saveSkuItem(skuItem, callback) {
        let self = this;

        //#region Save Ref SKU

        let urlSave = `${self.$root.baseUrl}/stage-management/change-ref-sku/`;
        let requestData = {
          create_by: self.createBy,
          username: self.loginUser,
          ftie_id: self.nreData.page_object.basic_info_review.ftie_id,
          nre_id: self.nreData.page_object.basic_info_review.nre_id,
          real_sku_no: self.nreData.page_object.basic_info_review.real_sku_no,
          model_name: self.nreData.page_object.basic_info_review.nre_model,
          ref_sku_object: skuItem
        };

        eventHub.$emit('loading', true);
        self.$axios
          .post(urlSave, requestData)
          .then(resSave => {

            self.reload(callback, 'page_object.ref_skus[0]');

          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });

        //#endregion

      },

      //#endregion

      //#region -- Change Referance PN --

      showRefPnModal() {
        let self = this;
        self.refPnObj = { pn: null, state: false };
        self.$refs['RefPnModal'].show();
      },

      changeReferancePn(bvModalEvt) {
        let self = this;
        bvModalEvt.preventDefault();

        self.refPnObj.state = _.trim(_.get(self.refPnObj, 'pn', '')) === '';

        if (self.refPnObj.state === true)
          return;

        let url = `${self.$root.baseUrl}/stage-management/get-pn-cost/?part_no=${encodeURIComponent(self.refPnObj.pn)}`;

        eventHub.$emit('loading', true);
        self.$axios
          .get(url)
          .then(res => {
            let cost = Number(_.get(res, 'data.ref_pn_cost', 0));
            self.nreData.page_object.unit_estimation_from_espm.cost_base_unit.poc_cost = self.pocRequired ? cost : 0;
            self.nreData.page_object.unit_estimation_from_espm.cost_base_unit.mp_cost = cost;
            self.nreData.page_object.unit_estimation_from_espm.cost_base_unit.remark = _.trim(self.refPnObj.pn);

            self.$nextTick(() => {
              self.$refs['RefPnModal'].hide();
            })

            eventHub.$emit('loading', false);

          });
      },

      //#endregion

      //#region -- PoC Required Change Event --

      pocRequiredChange() {
        let self = this;
        if (self.pocRequired) {
          self.nreData.page_object.nre_estimation_from_espm.labor_cost.development.poc_cost = self.tmpData.page_object.nre_estimation_from_espm.labor_cost.development.poc_cost
          self.nreData.page_object.nre_estimation_from_espm.labor_cost.verification.poc_cost = self.tmpData.page_object.nre_estimation_from_espm.labor_cost.verification.poc_cost
          self.nreData.page_object.nre_estimation_from_espm.test_sample.poc_cost = self.tmpData.page_object.nre_estimation_from_espm.test_sample.poc_cost
          self.nreData.page_object.nre_estimation_from_espm.job_cost.tooling_fee.poc_cost = self.tmpData.page_object.nre_estimation_from_espm.job_cost.tooling_fee.poc_cost
          self.nreData.page_object.nre_estimation_from_espm.job_cost.pcb_fee.poc_cost = self.tmpData.page_object.nre_estimation_from_espm.job_cost.pcb_fee.poc_cost
          self.nreData.page_object.nre_estimation_from_espm.job_cost.test_jig.poc_cost = self.tmpData.page_object.nre_estimation_from_espm.job_cost.test_jig.poc_cost
          self.nreData.page_object.nre_estimation_from_espm.job_cost.outsource_fee.poc_cost = self.tmpData.page_object.nre_estimation_from_espm.job_cost.outsource_fee.poc_cost
          self.nreData.page_object.nre_estimation_from_espm.job_cost.job_cost_others.poc_cost = self.tmpData.page_object.nre_estimation_from_espm.job_cost.job_cost_others.poc_cost
          self.nreData.page_object.nre_estimation_from_espm.regulation.emc.poc_cost = self.tmpData.page_object.nre_estimation_from_espm.regulation.emc.poc_cost
          self.nreData.page_object.nre_estimation_from_espm.regulation.safety.poc_cost = self.tmpData.page_object.nre_estimation_from_espm.regulation.safety.poc_cost
          self.nreData.page_object.nre_estimation_from_espm.regulation.environment.poc_cost = self.tmpData.page_object.nre_estimation_from_espm.regulation.environment.poc_cost
          self.nreData.page_object.nre_estimation_from_espm.regulation.regulation_others.poc_cost = self.tmpData.page_object.nre_estimation_from_espm.regulation.regulation_others.poc_cost
          self.nreData.page_object.nre_estimation_from_espm.others.poc_cost = self.tmpData.page_object.nre_estimation_from_espm.others.poc_cost
          self.nreData.page_object.unit_estimation_from_espm.demand_quantity.poc_cost = self.tmpData.page_object.unit_estimation_from_espm.demand_quantity.poc_cost
          self.nreData.page_object.unit_estimation_from_espm.cost_base_unit.poc_cost = self.tmpData.page_object.unit_estimation_from_espm.cost_base_unit.poc_cost
          self.nreData.page_object.unit_estimation_from_espm.additional_material_cost.poc_cost = self.tmpData.page_object.unit_estimation_from_espm.additional_material_cost.poc_cost
          self.nreData.page_object.unit_estimation_from_espm.additional_mva_cost.poc_cost = self.tmpData.page_object.unit_estimation_from_espm.additional_mva_cost.poc_cost
          self.nreData.page_object.lead_time_notice.week_poc = self.tmpData.page_object.lead_time_notice.week_poc
        }
        else {
          // Include PoC = 'Y' or PoC = 'N'
          if (self.pocChosen) {
            self.nreData.page_object.nre_estimation_from_espm.labor_cost.development.poc_cost = 0;
            self.nreData.page_object.nre_estimation_from_espm.labor_cost.verification.poc_cost = 0;
            self.nreData.page_object.nre_estimation_from_espm.test_sample.poc_cost = 0;
            self.nreData.page_object.nre_estimation_from_espm.job_cost.tooling_fee.poc_cost = 0;
            self.nreData.page_object.nre_estimation_from_espm.job_cost.pcb_fee.poc_cost = 0;
            self.nreData.page_object.nre_estimation_from_espm.job_cost.test_jig.poc_cost = 0;
            self.nreData.page_object.nre_estimation_from_espm.job_cost.outsource_fee.poc_cost = 0;
            self.nreData.page_object.nre_estimation_from_espm.job_cost.job_cost_others.poc_cost = 0;
            self.nreData.page_object.nre_estimation_from_espm.regulation.emc.poc_cost = 0;
            self.nreData.page_object.nre_estimation_from_espm.regulation.safety.poc_cost = 0;
            self.nreData.page_object.nre_estimation_from_espm.regulation.environment.poc_cost = 0;
            self.nreData.page_object.nre_estimation_from_espm.regulation.regulation_others.poc_cost = 0;
            self.nreData.page_object.nre_estimation_from_espm.others.poc_cost = 0;
            self.nreData.page_object.unit_estimation_from_espm.demand_quantity.poc_cost = 0;
            self.nreData.page_object.unit_estimation_from_espm.cost_base_unit.poc_cost = 0;
            self.nreData.page_object.unit_estimation_from_espm.additional_material_cost.poc_cost = 0;
            self.nreData.page_object.unit_estimation_from_espm.additional_mva_cost.poc_cost = 0;
            self.nreData.page_object.lead_time_notice.week_poc = 0;
          }
          else {
            self.nreData.page_object.nre_estimation_from_espm.labor_cost.development.poc_cost = 0;
            self.nreData.page_object.nre_estimation_from_espm.labor_cost.verification.poc_cost = 0;
            self.nreData.page_object.nre_estimation_from_espm.test_sample.poc_cost = 0;
            self.nreData.page_object.nre_estimation_from_espm.job_cost.tooling_fee.poc_cost = 0;
            self.nreData.page_object.nre_estimation_from_espm.job_cost.pcb_fee.poc_cost = 0;
            self.nreData.page_object.nre_estimation_from_espm.job_cost.test_jig.poc_cost = 0;
            self.nreData.page_object.nre_estimation_from_espm.job_cost.outsource_fee.poc_cost = 0;
            self.nreData.page_object.nre_estimation_from_espm.job_cost.job_cost_others.poc_cost = 0;
            self.nreData.page_object.nre_estimation_from_espm.regulation.emc.poc_cost = 0;
            self.nreData.page_object.nre_estimation_from_espm.regulation.safety.poc_cost = 0;
            self.nreData.page_object.nre_estimation_from_espm.regulation.environment.poc_cost = 0;
            self.nreData.page_object.nre_estimation_from_espm.regulation.regulation_others.poc_cost = 0;
            self.nreData.page_object.nre_estimation_from_espm.others.poc_cost = 0;
            self.nreData.page_object.unit_estimation_from_espm.demand_quantity.poc_cost = 0;
            //self.nreData.page_object.unit_estimation_from_espm.cost_base_unit.poc_cost = 0;
            self.nreData.page_object.unit_estimation_from_espm.additional_material_cost.poc_cost = 0;
            self.nreData.page_object.unit_estimation_from_espm.additional_mva_cost.poc_cost = 0;
            self.nreData.page_object.lead_time_notice.week_poc = 0;
          }
        }

        self.refreshQuoteItems();
      },

      //#endregion

      //#region -- Currency Change Events --

      onCurrencyChanged() {
        let self = this;
        let msg = `Are you sure you want to convert the currency?

The currency numbers in the page may be distorted due to rounding the number and "Customize Quote Items" need to be updated to new currency manually.`;

        let options = {
          okTitle: 'Convert',
        };
        self.$root.msgBoxConfirm(msg, self.applyCurrencyChange, options);

      },

      applyCurrencyChange(result) {
        let self = this;
        if (!result) {
          self.currency = _.first(self.nreData.page_object.ref_skus).region;
        }
        else {

          if (_.trim(self.currency) !== '') {
            _.forEach(self.pricePropertyPath, path => {
              _.set(self.nreData, path, _.round(_.get(self.nreData, path, 0) / self.currencyRateNreData * self.currencyRate, 2));
            });
            _.first(self.nreData.page_object.ref_skus).region = self.currency;
          }

          self.changeSkuItem(self.skuItem.sku_id, () => {
            self.saveData();
          });
        }

      },

      //#endregion

      //#region -- Add/Edit/Delete Quote Item --

      quoteTypeChanged() {
        let self = this;
        if (_.get(self.quoteItemObj, 'quote_type', 'MP').match(/^POC/)) {
          self.quoteItemObj.qtyMax = 20;
          if (self.quoteItemObj.qty == null || self.quoteItemObj.qty > self.quoteItemObj.qtyMax) self.quoteItemObj.qty = 1;
        }
        else {
          self.quoteItemObj.qtyMax = 1;
          self.quoteItemObj.qty = 1;
        }
      },
      showQuoteItemModal(item) {
        let self = this;
        let isNew = _.isNil(item);
        let createFunctionMatch = self.createFunction;
        if ('ES PM Leader' == createFunctionMatch) {
          createFunctionMatch = 'ES PM';
        }

        if (isNew) {
          self.quoteItemObj = {
            action: 'Add',
            create_function: createFunctionMatch,
            sales_force_opty: self.nreData.page_object.basic_info_review.sales_force_opty,
            ftie_id: self.nreData.page_object.basic_info_review.ftie_id,
            sku_id: self.nreData.page_object.basic_info_review.sku_id, // customization SKU ID
            quote_type: null,
            qty: null,
            qtyMax: 1,
            sku_description: self.nreData.page_object.sku_description, //self.nreData.page_object.sku_description,
            customization_description: null,
            quote_type_state: false,
            qty_state: false,
            ticket_type: self.nreData.page_object.basic_info_review.ticket_type
          };
          self.quoteItemObj.quote_type = _.first(self.aliveQuoteTypes);
        }
        else {
          self.quoteItemObj = JSON.parse(JSON.stringify(item));
          self.quoteItemObj.action = 'Update';
          self.quoteItemObj.ticket_type = self.nreData.page_object.basic_info_review.ticket_type;
        }

        /*  NEW: The stdSku has be changed by ES PM, the default sku_id and sku_description in custom quote section should be change too*/
        let stdSkuId = null;
        let stdSkuDescription = null;
        let customSkuId = null;
        if (_.get(self.nreData.page_object, 'ref_skus', null) !== null && _.size(self.nreData.page_object.ref_skus) > 0) {
          stdSkuId = _.get(self.nreData.page_object.ref_skus[0], 'sku_id', null)
          stdSkuDescription = _.get(self.nreData.page_object.ref_skus[0], 'description', null)
          if (stdSkuId !== null) {
            if (_.size(stdSkuId) === 12) {
              customSkuId = stdSkuId.substring(0, 10) + '9' + stdSkuId.substring(11);
            }
            else {
              if (_.size(stdSkuId) > 2) {
                customSkuId = stdSkuId.substring(0, _.size(stdSkuId) - 2) + '9' + stdSkuId.substring(_.size(stdSkuId) - 1);
              }
            }

          }
        }

        if (customSkuId !== null && self.nreData.page_object.basic_info_review.sku_id !== customSkuId) {
          _.set(self.quoteItemObj, 'sku_id', customSkuId);
          /*
          console.log("customSkuId has been changed, but page_object.basic_info_review.sku_id remain the same");
          console.log("customSkuId = ");
          console.log(customSkuId);
          console.log("customSkuId = ");
          console.log(customSkuId);
          */

        }

        if (stdSkuDescription !== null && self.nreData.page_objectsku_description !== stdSkuDescription) {
          _.set(self.quoteItemObj, 'sku_description', stdSkuDescription);

        }

        /* endregion */

        self.quoteTypeChanged();

        self.quoteItemObj.action = isNew ? 'Add' : 'Update';

        //self.$refs['QuoteItemModal'].show();
        if ( _.get(self.nreData, 'page_object.basic_info_review.ticket_type', null) === 'ETO Sector SKU') {
          //console.log("ETO Sector SKU QUOTE ITEM");
          self.$refs['ETOSelectQuoteItemModal'].show();
        } else {
          self.$refs['QuoteItemModal'].show();
        }

      },
      saveQuoteItem(bvModalEvt) {
        let self = this;
        let index = 0;
        bvModalEvt.preventDefault();

        if (_.trim(self.quoteItemObj.quote_type) === '') self.quoteItemObj.quote_type_state = true;
        if (_.trim(self.quoteItemObj.qty) === '') self.quoteItemObj.qty_state = true;

        if (self.quoteItemObj.quote_type_state || self.quoteItemObj.qty_state) return;

        switch (self.quoteItemObj.action) {
          case 'Add':
            index = _.get(self.nreData.page_object.quote_items, 'length', 0);
            self.nreData.page_object.quote_items.push(self.quoteItemObj);
            self.refreshQuoteItems();
            self.saveQuoteItemToServer('add', index);
            break;
          case 'Update':
            index = _.findIndex(self.nreData.page_object.quote_items, { uni_id: self.quoteItemObj.uni_id });
            self.$set(self.nreData.page_object.quote_items, index, self.quoteItemObj);
            self.refreshQuoteItems();
            self.saveQuoteItemToServer('modified', index);
            break;
          default:
        }

        self.$nextTick(() => {
          self.$refs['QuoteItemModal'].hide();
          self.$refs['ETOSelectQuoteItemModal'].hide();
          self.quoteItemObj = self.$options.data().quoteItemObj; // reset quoteItemObj
        })

      },
      saveQuoteItemToServer(action, index) {
        let self = this;
        let requestData = {
          create_by: self.createBy,
          username: self.loginUser,
          create_date: self.$root.getTime(),
          create_function: self.createFunction,
          ftie_id: self.nreData.page_object.basic_info_review.ftie_id,
          nre_id: self.nreData.page_object.basic_info_review.nre_id,
          ticket_type: self.nreData.page_object.basic_info_review.ticket_type,
          quote_to_gro: null,
          real_sku_no: self.nreData.page_object.basic_info_review.real_sku_no,
          sales_force_opty: self.nreData.page_object.basic_info_review.sales_force_opty,
          sku_id: self.nreData.page_object.basic_info_review.sku_id,
          uni_id: _.get(self.nreData.page_object.quote_items[index], 'uni_id', null),

          action: action,
          cost_remark: self.nreData.page_object.unit_estimation_from_espm.cost_base_unit.remark,
          currency: self.currency,
          hq_cost: self.nreData.page_object.quote_items[index].hq_cost,
          add_quote: self.nreData.page_object.quote_items[index],
          amortization_qty: self.nreData.page_object.unit_estimation_from_espm.nre_amortization.nre_amortization_quantity
        };
        //console.log("saveQuoteItemToServer requestData:");
        //console.log(requestData);
        eventHub.$emit('loading', true);
        self.$axios
          .post(self.$root.baseUrl + '/stage-management/quote-save/', requestData)
          .then(res => {

            if (_.get(res, 'data.insert_success', false)) {
              self.$set(self.nreData.page_object.quote_items, index, JSON.parse(res.data.updated_quote));
              self.tmpData.page_object.quote_items = JSON.parse(JSON.stringify(self.nreData.page_object.quote_items));
            }
            else {
              self.nreData.page_object.quote_items = JSON.parse(JSON.stringify(self.tmpData.page_object.quote_items));
              self.refreshQuoteItems();
              self.$message.error(`${action === 'add' ? 'Insert' : 'Edit'} Quote Item Failed!`);
            }

            eventHub.$emit('loading', false);
          });
      },
      removeQuoteItemToServer(item) {
        let self = this;
        let request_data = {
          create_by: self.createBy,
          username: self.loginUser,
          uni_id: item.uni_id,
          create_function: self.createFunction
        };

        eventHub.$emit('loading', true);
        self.$axios.post(self.$root.baseUrl + '/stage-management/quote-delete/', request_data)
          .then(res => {

            if (_.get(res, 'data.delete_success', false)) {
              self.nreData.page_object.quote_items = _.remove(self.nreData.page_object.quote_items, item => { return item.uni_id !== res.data.delete_uni_id });
            }
            else {
              self.nreData.page_object.quote_items = JSON.parse(JSON.stringify(self.tmpData.page_object.quote_items));
              self.refreshQuoteItems();
              self.$message.error("Delete Quote Item Failed!");
            }

            eventHub.$emit('loading', false);
          })
      },

      //#endregion

      //#region -- check status for reason section enabel
      checkStatusForReasonDetail() {
        let self = this;
        let statusNames = ['Cancel', 'Rejected', 'Reject', 'Canceled', 'Deferred'];
        let dataStatus = _.trim(_.get(self.nreData, 'last_update_status', ''));//self.nreData.last_update_status
        self.showReasonSection = _.indexOf(statusNames, dataStatus) > -1 && dataStatus !== '';
      },
      //#endregion

      //#region -- Refresh Quote Item --

      refreshQuoteItems() {
        let self = this;
        let isEqual = false;

        if (self.includeStages(['10', '20'])) {
          self.refreshQuoteItemAmortizeQty();
          self.refreshQuoteItemHqCost();
        }
        else if (self.includeStages(['30'])) {
          isEqual = self.detectNreAmortizationQuantity();
          self.refreshQuoteItemAmortizeQty();
          if (!isEqual) self.refreshQuoteItemHqCost();
          self.refreshQuoteItemGroCost();
        }
        else if (self.includeStages(['40'])) {
          isEqual = self.detectNreAmortizationQuantity();
          self.refreshQuoteItemAmortizeQty();
          if (!isEqual) self.refreshQuoteItemGroCost();
          self.refreshQuoteItemSellingPrice();
        }
        else {
        }
      },

      detectNreAmortizationQuantity() {
        let self = this;

        if (!_.includes(['HQ Sales Review', 'SA Head Review'], self.createFunction)) return true;

        let pageObject = self.nreData.page_object;
        let baseUnit = _.get(pageObject, self.createFunction === 'HQ Sales Review' ? 'unit_estimation_from_espm' : 'unit_estimation_hq_sales');
        let current = _.get(pageObject, 'unit_estimation_curr_stage', null);
        if (_.isNil(baseUnit) || _.isNil(current)) return true;

        // let needNewRecord = (baseUnit.nre_amortization.nre_amortization_quantity !== current.nre_amortization.nre_amortization_quantity) || (baseUnit.nre_amortization.nre_amortization_check !== current.nre_amortization.nre_amortization_check);
        // if (needNewRecord === false) return true;

        let data = _.filter(self.quoteItemsMapping, (quoteItemsMapping) => { return quoteItemsMapping.quote_type === 'MP' || quoteItemsMapping.quote_type === 'MP Addition Cost'; });

        _.each(data, baseItem => {

          let item = _.find(pageObject.quote_items, { create_function: self.createFunction, quote_type: baseItem.quote_type });

          if (_.isNil(item)) {
            item = {
              ...baseItem,
              create_function: self.createFunction,
              uni_id: null
            };
            pageObject.quote_items.push(item);
          }
        });

        return false;
      },
      refreshQuoteItemAmortizeQty() {
        let self = this;
        let createFunction = self.createFunction;
        if (createFunction === 'ES PM Leader') createFunction = 'ES PM';

        let qty = 0;
        if (self.includeStages(['10', '20']))
          qty = self.nreData.page_object.unit_estimation_from_espm.nre_amortization.nre_amortization_quantity;
        else if (self.includeStages(['30', '40'])) {
          if (self.nreData.page_object.unit_estimation_curr_stage.nre_amortization.nre_amortization_check === 'Y') {
            qty = self.nreData.page_object.unit_estimation_curr_stage.nre_amortization.nre_amortization_quantity;
          }
        }

        _.each(_.filter(self.nreData.page_object.quote_items, { create_function: createFunction }), item => {

          self.$set(item, 'amortize_qty', qty);

        });
      },
      refreshQuoteItemHqCost() {
        let self = this;
        let createFunction = self.createFunction;
        if (createFunction === 'ES PM Leader') createFunction = 'ES PM';
        let range = [];

        let pageObject = self.nreData.page_object;
        let baseUnit = null;
        let baseNre = null;

        if (createFunction === 'ES PM' || createFunction === 'ES PM Leader') {
          baseNre = pageObject.nre_estimation_from_espm;
          baseUnit = pageObject.unit_estimation_from_espm;
          range = ['ES PM', 'ES PM Leader'];
        }
        else if (createFunction === 'HQ Sales Review') {
          baseNre = pageObject.nre_estimation_from_espm;
          baseUnit = pageObject.unit_estimation_from_espm;
          range = ['HQ Sales Review'];
        }
        else {
          return;
        }

        let data = _.filter(pageObject.quote_items, item => { return _.includes(range, item.create_function); });

        _.each(data, item => {
          self.refreshQuoteItem(item, 'hq_cost', baseNre, baseUnit);
        });
      },
      refreshQuoteItemGroCost() {
        let self = this;

        let createFunction = self.createFunction;
        if (createFunction === 'ES PM Leader') createFunction = 'ES PM';

        let pageObject = self.nreData.page_object;
        let baseUnit = null;
        let baseNre = null;
        let range = ['ES PM', 'ES PM Leader', 'HQ Sales Review'];

        if (createFunction === 'ES PM' || createFunction === 'ES PM Leader') {
          // ES PM / ES PM Leader 僅負責 HQ Cost
          return;
        }
        else if (createFunction === 'HQ Sales Review') {
          baseNre = pageObject.nre_estimation_curr_stage;
          baseUnit = pageObject.unit_estimation_curr_stage;
        }
        else if (createFunction === 'SA Head Review') {
          range = ['SA Head Review'];
          baseNre = pageObject.nre_estimation_hq_sales;
          baseUnit = pageObject.unit_estimation_hq_sales;
        }

        let data = _.filter(pageObject.quote_items, item => { return _.includes(range, item.create_function); })

        _.each(data, item => {
          self.refreshQuoteItem(item, 'gro_cost', baseNre, baseUnit);
        });

      },
      refreshQuoteItemSellingPrice() {
        let self = this;

        let createFunction = self.createFunction;
        if (createFunction === 'ES PM Leader') createFunction = 'ES PM';

        let pageObject = self.nreData.page_object;
        let baseUnit = null;
        let baseNre = null;
        let range = ['ES PM', 'ES PM Leader', 'HQ Sales Review', 'SA Head Review'];

        if (createFunction === 'SA Head Review') {
          baseNre = pageObject.nre_estimation_curr_stage;
          baseUnit = pageObject.unit_estimation_curr_stage;
        }
        else {
          return;
        }

        let data = _.filter(pageObject.quote_items, item => { return _.includes(range, item.create_function); })

        _.each(data, item => {
          self.refreshQuoteItem(item, 'selling_price', baseNre, baseUnit);
        });

      },

      refreshQuoteItem(item, col, baseNre, baseUnit) {
        let self = this;
        let finalTotalPocCost = 0;
        let finalTotalMPCost = 0;
        if (self.includeStages(['40', '50', '60', '65', '70'])) {
          let pocCols = [
            baseNre.labor_cost.poc_cost,
            baseNre.test_sample.poc_cost,
            baseNre.job_cost.poc_cost,
            baseNre.regulation.regulation_others.poc_cost,
            baseNre.total_cost.poc_cost
          ];
          let mpCols = [
            baseNre.labor_cost.mp_cost,
            baseNre.test_sample.mp_cost,
            baseNre.job_cost.mp_cost,
            baseNre.regulation.regulation_others.mp_cost,
            baseNre.total_cost.mp_cost
          ];
          finalTotalPocCost = _.round(_.sum(pocCols), 2);
          finalTotalMPCost = _.round(_.sum(mpCols), 2);
        } else {
          finalTotalPocCost = baseNre.total_cost.poc_cost;
          finalTotalMPCost = baseNre.total_cost.mp_cost;
        }
        switch (item.quote_type) {

          case 'POC NRE':
            self.$set(item, col, finalTotalPocCost)
            break;
          case 'MP NRE':
            self.$set(item, col, finalTotalMPCost)
            break;
          case 'POC':
            self.$set(item, col, baseUnit.total_cost.poc_cost * item.qty
              + finalTotalPocCost)
            break;
          case 'MP':
            self.$set(item, col, baseUnit.total_cost.mp_cost)
            break;
          case 'MP Addition Cost':
            self.$set(item, col, _.sum([
              baseUnit.additional_material_cost.mp_cost,
              baseUnit.additional_mva_cost.mp_cost,
              baseUnit.nre_amortization.nre_amortization_cost
            ]))
            break;
          case 'POC Addition Cost':
            self.$set(item, col, _.sum([
              baseUnit.additional_material_cost.poc_cost,
              baseUnit.additional_mva_cost.poc_cost
            ]) * item.qty
              + finalTotalPocCost)
            break;
          default:
        }

        self.$set(item, col, _.round(_.get(item, col, 0), 2));

      },

      //#endregion

      //#region -- Upload File Methods --
      uploadProjectProposalFile(file) {
        let self = this;
        self.uploadFile(file, 'Project Proposal file');
      },
      uploadReferenceFile(file) {
        let self = this;
        self.uploadFile(file, 'ES PM');
      },
      uploadFile(file, type) {
        let self = this;

        let path = null;
        switch (type) {
          case 'Project Proposal file':
            path = 'page_object.proposal_files';
            break;
          case 'ES PM':
            path = 'page_object.reference_files';
            break;
          case 'Project Request Form':
          case 'Project Feasibility Check (RDS)':
          case 'Project SOW':
          case 'Project Charter DCP':
          case 'Project Charter Package':
          case 'Project Kickoff Meeting Minutes':
            path = 'page_object.kickoff_files';
            break;
          default:
        }

        //#region -- Data Validate --

        let maxLength = Number(self.$root.maxRequestLength);
        if (file.size > maxLength) {
          self.$message.warning('Maximum limit for exceeding single file uploads (10MB)');
          return;
        }

        //#endregion

        //#region -- formData --
        let formData = new FormData();
        formData.append('file', file);
        formData.append('category', type);
        formData.append('create_by', self.createBy);
        formData.append('username', self.loginUser);
        formData.append('ftie_id', self.nreData.page_object.basic_info_review.ftie_id);
        formData.append('nre_id', self.nreData.page_object.basic_info_review.nre_id);
        formData.append('real_sku_no', self.nreData.page_object.basic_info_review.real_sku_no);
        //#endregion

        //#region -- Data Upload --

        eventHub.$emit('loading', true);
        self.$axios
          .post(
            self.$root.baseUrl + '/stage-management/upload_file/',
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
          )
          .then(res => {
            self.reload(null, path);
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });

        //#endregion

      },
      //#endregion

      //#region -- Delete File Methods --
      deleteProjectProposalFile(index) {
        let self = this;
        self.deleteFile(index, 'Project Proposal file');
      },
      deleteReferenceFile(index) {
        let self = this;
        self.deleteFile(index, 'ES PM');
      },
      deleteFile(index, type) {
        let self = this;
        index = Number(index)

        //#region -- Data Validate --

        if (_.isNaN(index) || index < 0) return;

        let source = null
        let path = null;
        switch (type) {
          case 'Project Proposal file':
            source = self.nreData.page_object.proposal_files;
            path = 'page_object.proposal_files';
            break;
          case 'ES PM':
            source = self.nreData.page_object.reference_files;
            path = 'page_object.reference_files';
            break;
          case 'Project Request Form':
          case 'Project Feasibility Check (RDS)':
          case 'Project SOW':
          case 'Project Charter DCP':
          case 'Project Charter Package':
          case 'Project Kickoff Meeting Minutes':
            source = self.kickoffFiles;
            path = 'page_object.kickoff_files';
            break;
          default:
        }

        if (_.get(source, 'length', 0) <= index) return;

        //#endregion

        let requestData = {
          category: type,
          uni_key: source[index].uni_key,
          uni_id: source[index].uni_id,
          create_by: self.createBy,
          username: self.loginUser
        };

        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/stage-management/delete_file/', requestData)
          .then(res => {
            self.reload(null, path);
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },
      getFile(file) {
        let self = this;
        let params = {
          file_url: file.file_url
        };
        let queryString = `file_url=${file.file_url}`;
        let url = `${self.$root.baseUrl}/${self.stageApiBase}/get_file/`;
        eventHub.$emit('loading', true);
        self.$axios.post(url, params, { responseType: 'arraybuffer' })
          .then((res) => {
            if (res.status === 200) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', file.file_name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });

      },

      // TODO: NEW REPORT DOWNLOAD
      getInventoryReport(file) {
        let self = this;
        let params = {
          file_url: file.file_url
        };
        let queryString = `file_url=${file.file_url}`;
        let url = `${self.$root.baseUrl}/inventory/unique_component/download/`;
        eventHub.$emit('loading', true);
        self.$axios.post(url, params, { responseType: 'arraybuffer' })
          .then((res) => {
            if (res.status === 200) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', file.file_name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });

      },
      //#endregion

      //#endregion

      //#region -- NreData Load/Save/Submit/Withdraw/Reject/Return/ConditionalApprove/KickOff --

      saveTmpData(nreData) {
        this.tmpData = JSON.parse(JSON.stringify(nreData));
      },

      reload(callback, keyPath) {
        let self = this;
        let nreData = null;

        //#region Load NreData

        let ftie_id = encodeURIComponent(self.$route.params.ftie_id);
        let nre_id = encodeURIComponent(self.$route.params.nre_id);
        let real_sku_no = encodeURIComponent(self.$route.params.real_sku_no);
        let create_by = encodeURIComponent(self.$route.params.create_by);
        let baseUrl = _.trim(self.$root.baseUrl);

        let queryString = `ftie_id=${ftie_id}&nre_id=${nre_id}&real_sku_no=${real_sku_no}&create_by=${create_by}`;
        let url = `${baseUrl}/${self.stageApiBase}/${self.stageApiName}?${queryString}`;

        let params = {
          username: self.loginUser
        };

        eventHub.$emit('loading', true);

        self.$axios.get(url, { params })
          .then((res) => {
            nreData = res.data;
            nreData.page_object = JSON.parse(nreData.page_object);

            let ref_skus = _.get(nreData, 'page_object.ref_skus', [{ region: '' }]);
            if (ref_skus.length > 0 && _.first(ref_skus).region !== '') {
              self.currency = _.first(nreData.page_object.ref_skus).region;
            }

          })
          .finally(() => {
            eventHub.$emit('loading', false);
            self.checkStatusForReasonDetail();

            if (_.trim(keyPath) === '') {
              self.nreData = nreData;
            }
            else {
              if (self.stageApiName === 'espm-kickoff') {
                self.nreData = nreData;
              } else {
                let tmp = JSON.parse(JSON.stringify(self.nreData));
                _.set(tmp, keyPath, _.get(nreData, keyPath));
                self.nreData = tmp;
              }
            }
            self.saveTmpData(nreData);


            if (self.checkLoggedIn() && _.isFunction(callback)) {
              callback();
            }
          });

        //#endregion

      },

      postNreData(action, comments) {
        let self = this;

        let rejectReason = action === 'reject' ? comments : null;
        let deferReason = action === 'deferred' ? comments : null;
        let returnReason = action === 'return' ? comments : null;
        let cancelReason = action === 'cancel' ? comments : null;

        let selected_quote_for_gro = [];
        if (self.includeStages('80')) {

          if (action === 'reject') {
            _.each(self.nreData.page_object.quote_items, item => { item.quote_to_gro = 'N'; });
          }


          selected_quote_for_gro = _.filter(self.nreData.page_object.quote_items, { quote_to_gro: 'T' })
          if (action === 'submit' || action === 'deferred') {
            _.each(_.filter(self.nreData.page_object.quote_items, { quote_to_gro: 'T' }), item => { item.quote_to_gro = 'Y'; });
          }

        }
        if (self.includeStages('40') && self.isETOSELECT) {
          console.log("STAGE 40 AND is ETO Sector SKU");
          selected_quote_for_gro = _.filter(self.nreData.page_object.quote_items, { create_function: 'SA Head Review' })
          if (action === 'submit') {
            _.each(_.filter(self.nreData.page_object.quote_items, { create_function: 'SA Head Review' }), item => { item.quote_to_gro = 'E'; });
          }
        }
        let requestData = {
          button: action,
          stage: self.stageNumber,
          create_by: self.createBy,
          username: self.loginUser,
          create_date: self.$root.getTime(),
          nre_object: {
            ...self.nreData.page_object,
            deferred_reason: deferReason,
            reject_reason: rejectReason,
            return_reason: returnReason,
            cancel_reason: cancelReason
          },
          selected_quote_for_gro: selected_quote_for_gro
        };
        let url = `${self.$root.baseUrl}/${self.stageApiBase}/${self.stageApiName}/`;

        eventHub.$emit('loading', true);
        self.$axios
          .post(url, requestData)
          .then(res => {
            if (_.get(res, 'data.save_success', false)) {
              if (action === 'return') {
                let nre_id = requestData.nre_object.basic_info_review.nre_id;
                self.tmpData = self.nreData;// avoid show confirm modal when data change
                //console.log(`action === 'return', nre_id = ${nre_id}`);
                let dashboard_url = `${self.$root.frontEndUrl}/dashboard/${nre_id}`;
                window.location.href = dashboard_url;
              } else if (action === 'withdraw') {
                let nre_id = requestData.nre_object.basic_info_review.nre_id;
                let ftie_id = requestData.nre_object.basic_info_review.ftie_id;
                let sku_id = self.nreData.page_object.basic_info_review.sku_id;
                let real_sku_no = self.nreData.page_object.basic_info_review.real_sku_no
                let espm_submit_url =`${self.$root.frontEndUrl}/espm-submitted/${ftie_id}/${sku_id}/${nre_id}/${real_sku_no}/${self.createBy}`;
                window.location.href = espm_submit_url;
              } else {
                self.reload();
              }

            }

            eventHub.$emit('loading', false);
          });
      },
      collapseSignflow() {
        let self = this;
        self.$refs['signflowModal'].show()
      },
      adminRole() {
        let self = this;
        let adminRole = false;
        var user_roles = this.$session.get('user_roles');
        /*
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }
        var user_name = this.$session.get('user_name');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_site = this.$session.get('user_site');
        this.login_user_name = user_name;
        this.userEmail = user_email;
        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;
        this.releaseNotes = release_notes;
        this.etoDefinition = eto_definition;
        */
        if (user_roles !== null && (_.indexOf(user_roles, 'Admin') > -1 || self.loginUser === 'power')) {
          adminRole = true;
        }
        console.log(`adminRole=` + adminRole);
        return adminRole;
      },
      validateComments(commentKey) {
        let self = this; // commentKey = 'rsm_comment'
        if (_.get(self.nreData.page_object, commentKey, null) === null || _.trim(_.get(self.nreData.page_object, commentKey, '')) === '' || 'N/A' === _.get(self.nreData.page_object, commentKey, null)) {
          self.$message.warning(`Please enter some comments for this NRE so that the teams at GTC and GRO can refer to it.`);
          return false;
        }
        return true;
        //_.each(self.nreData.page_object.quote_items, item => { item.quote_to_gro = 'N'; });
      },
      saveData() {
        this.postNreData('save');
      },
      submitData(commentKey = null) {
        let self = this;
        let validateResult = true;
        if (commentKey !== null) {
          validateResult = self.validateComments(commentKey);
        }
        if (validateResult) {
          let callback = result => {
            if (result)
              self.postNreData('submit');
          }
          let options = {
            title: 'Submit',
            titleClass: null,
            size: null,
            buttonSize: null,
            okVariant: null,
            okTitle: 'Submit',
            cancelTitle: null
          };
          self.$root.msgBoxConfirm(`Are you sure want to submit?`, callback, options);
        }

      },
      autoApproveData() {
        let self = this;
        let callback = result => {
          if (result)
            self.postNreData('auto_approve');
        }

        self.autoApproveObj = {
          title: 'Auto Approve',
          titleClass: null,
          size: null,
          buttonSize: null,
          okVariant: null,
          okTitle: 'Approve',
          cancelTitle: 'Cancel',

          action: 'auto_approve',
          message1: 'Are you sure want to auto-approve this NRE?',
          message2: 'Please note that once the NRE has been auto-approved. It will bypass all the GRO-related stages and two HQ sales signing stages.',
          reason: 'auto approve',
          state: false,
          variant: 'primary',
          invalidFeedback: 'Please contact system admin for this error.'
        };

        self.$refs['AutoApproveModal'].show();

        //self.$root.msgBoxConfirm(`Are you sure want to auto-approve this NRE? Please note that...`, callback, options);
      },
      approveData() {
        let self = this;
        let callback = result => {
          if (result)
            self.postNreData('submit');
        }
        let options = {
          title: 'Approve',
          titleClass: null,
          size: null,
          buttonSize: null,
          okVariant: null,
          okTitle: 'Approve',
          cancelTitle: null
        };
        if (self.nreData.page_object.basic_info_review.create_function === 'GTC Sales Conformation') {
          self.$root.msgBoxConfirm(`Are you sure want to approve? If you want RSM to provide a quote to the customer ahead of project kick-off, please do not click approve, cancel this pop-up modal, and choose Deferred (Button on the left side of the Approve Button).`, callback, options);
        }
        else {
          self.$root.msgBoxConfirm(`Are you sure want to approve?`, callback, options);
        }
      },
      withdrawData() {
        let self = this;
        let callback = result => {
          if (result)
            self.postNreData('withdraw');
        }
        let options = {
          title: 'Withdraw',
          titleClass: 'text-danger',
          size: null,
          buttonSize: null,
          okVariant: 'danger',
          okTitle: 'Withdraw',
          cancelTitle: null
        };
        self.$root.msgBoxConfirm(`Are you sure want to withdraw?`, callback, options);
      },
      returnData() {
        let self = this;
        let callback = result => {
          if (result)
            self.postNreData('return');
        }
        self.reasonObj = {
          action: 'return',
          reason: null,
          state: false,
          variant: 'danger',
          title: 'Return',
          message1: 'Are you sure want to return?',
          message2: 'Please describe the reason for returning this quotation.',
          invalidFeedback: 'Please describe the reason for returning this NRE quotation!'
        };
        self.$refs['ReasonModal'].show();
      },
      rejectData() {
        let self = this;
        self.reasonObj = {
          action: 'reject',
          reason: null,
          state: false,
          variant: 'danger',
          title: 'Reject',
          message1: 'Are you sure want to reject?',
          message2: 'Please describe the reason for rejecting this quotation.',
          invalidFeedback: 'Please describe the reason for rejecting this NRE quotation!'
        };
        self.$refs['ReasonModal'].show();
      },
      deferData() {
        let self = this;
        self.reasonObj = {
          action: 'deferred',
          reason: null,
          state: false,
          variant: 'primary',
          title: 'Defer',
          message1: 'Are you sure want to defer?',
          message2: 'Please describe the reason for deferring this quotation.',
          invalidFeedback: 'Please describe the reason for deferring this NRE quotation!'
        };
        self.$refs['ReasonModal'].show();
      },
      reasonOK(bvModalEvt) {
        let self = this;
        bvModalEvt.preventDefault();

        if (_.trim(self.reasonObj.reason) === '') { self.reasonObj.state = true; return; }

        self.postNreData(self.reasonObj.action, self.reasonObj.reason);

        self.$nextTick(() => {
          self.$refs['ReasonModal'].hide();
        })

      },
      autoApproveOK(bvModalEvt) {
        let self = this;
        bvModalEvt.preventDefault();

        if (_.trim(self.autoApproveObj.reason) === '') { self.autoApproveObj.state = true; return; }

        self.postNreData(self.autoApproveObj.action, self.autoApproveObj.reason);

        self.$nextTick(() => {
          self.$refs['AutoApproveModal'].hide();
        })

      },
      conditionalApproveData() {
        let self = this;
        self.reasonObj = {
          action: 'conditional_approve',
          reason: null,
          state: false,
          variant: 'primary',
          title: 'Conditional Approve',
          message1: 'Are you sure want to conditional approve?',
          message2: 'Please describe the reason for conditional approving this NRE quotation.',
          invalidFeedback: 'Please describe the reason for conditional approving this NRE quotation!'
        };
        self.$refs['ReasonModal'].show();
      },

      projectCancelData() {
        let self = this;
        self.reasonObj = {
          action: 'cancel',
          reason: null,
          state: false,
          variant: 'danger',
          title: 'Cancel confirm',
          message1: 'Are you sure want to cancel this project?',
          message2: 'Please describe the reason for cancelling this project.',
          invalidFeedback: 'Please describe the reason for cancelling this project!',
          okTitle: 'Yes, Project cancel',
          cancelTitle: 'No'
        };
        self.$refs['ReasonModal'].show();

      },

      kickOffData() {
        //this.postNreData('kick-off');
        let self = this;
        let callback = result => {
          if (result)
            self.postNreData('kick-off');
        }
        let options = {
          title: 'Kickoff',
          titleClass: null,
          size: null,
          buttonSize: null,
          okVariant: null,
          okTitle: 'Project Kickoff',
          cancelTitle: null
        };
        self.$root.msgBoxConfirm(`Are you sure want to kickoff this project?`, callback, options);

      },
      getMpsQty() {
        let self = this;
        let url = `${self.$root.baseUrl}/stage-management/get-opty-mps-qty/`;
        let requestData = {
          ftie_id: self.nreData.page_object.basic_info_review.ftie_id
        };
        eventHub.$emit('loading', true);
        self.$axios
          .post(url, requestData)
          .then(res => {
            if (_.get(res, 'status', 0) == 200) {
              self.nreData.page_object.unit_estimation_from_espm.demand_quantity.mp_cost = _.get(res, 'data.mps_qty', 0);
            }
            else {
              this.$message.error(`Get Qty Failed!`);
            }
            

            //if (_.get(res, 'data.insert_success', false)) {
            //  self.$set(self.nreData.page_object.quote_items, index, JSON.parse(res.data.updated_quote));
            //  self.tmpData.page_object.quote_items = JSON.parse(JSON.stringify(self.nreData.page_object.quote_items));
            //}
            //else {
            //  self.nreData.page_object.quote_items = JSON.parse(JSON.stringify(self.tmpData.page_object.quote_items));
            //  self.refreshQuoteItems();
            //  self.$message.error(`${action === 'add' ? 'Insert' : 'Edit'} Quote Item Failed!`);
            //}

            eventHub.$emit('loading', false);
          });
      },

      //#endregion
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/NrePage.vue